<script >
const __sfc_main = {};
__sfc_main.props = {
  closable: {
    type: Boolean,
    default: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useTeleport
  } = require('@fegobull/webapi').use;
  useTeleport(document.body);
  const emits = __ctx.emit;
  const onClose = () => {
    emits('close');
  };
  return {
    onClose
  };
};
export default __sfc_main;
</script>

<template>
    <div class="my_act-modal">
        <div class="act-modal-mask"></div>
        <div class="act-modal-wrapper">
            <slot name="header" />
            <div class="act-modal-content">
                <slot />
            </div>
            <a
                v-if="closable !== false"
                href="javascript:void 0;"
                class="close-icon"
                @click="onClose"
            ></a>
        </div>
    </div>
</template>

<style lang="less">
.my_act-modal {
    position: fixed !important;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 101;
    .act-modal-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #1c1c1c;
    }
    .act-modal-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .act-modal-content {
        width: 100%;
        height: 100%;
    }
    .close-icon {
        width: 0.5rem;
        height: 0.5rem;
        background-image: url('../images/close-icon.png');
        background-size: contain;
        display: block;
        margin: .38rem auto 0;
    }
    &.is-pc {
        .close-icon {
            margin-top: 38px;
        }
    }
}
</style>
